import * as AccessibleIcon from '@radix-ui/react-accessible-icon';

const FacebookIcon = ({ type = 'default' }: { type?: 'default' | 'round' }): JSX.Element => {
	return (
		<AccessibleIcon.Root label='facebook'>
			<>
				{type === 'default' && (
					<svg viewBox='0 0 320 512' aria-hidden='true' focusable='false' role='presentation'>
						<path d='M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'></path>
					</svg>
				)}
				{type === 'round' && (
					<svg aria-hidden='true' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M2.00195 12.0721C2.00312 16.9915 5.58036 21.1801 10.439 21.9511V14.9621H7.90195V12.0721H10.442V9.87211C10.3284 8.82965 10.6845 7.79071 11.4136 7.03704C12.1427 6.28338 13.1693 5.89313 14.215 5.97211C14.9655 5.98423 15.7141 6.05108 16.455 6.17211V8.63111H15.191C14.7558 8.57412 14.3183 8.71784 14.0017 9.02178C13.6851 9.32572 13.5237 9.757 13.563 10.1941V12.0721H16.334L15.891 14.9631H13.563V21.9511C18.8174 21.1207 22.502 16.3219 21.9475 11.0312C21.3929 5.74048 16.7932 1.81004 11.4808 2.08729C6.16831 2.36454 2.0028 6.75242 2.00195 12.0721Z'
							fill='black'
						/>
					</svg>
				)}
			</>
		</AccessibleIcon.Root>
	);
};

export default FacebookIcon;
